import { Mail, Phone, MapPin, MessageCircle } from "lucide-react";
import Reveal from "@/components/Reveal";
import SectionEyebrow from "@/components/SectionEyebrow";
import Seo from "@/components/Seo";
import ContactForm from "@/components/ContactForm";
import { useLang } from "@/context/LanguageContext";
import { CONTACT_EMAIL, WHATSAPP_LINK } from "@/lib/config";
import FAQ from "@/components/FAQ";
import { contactFaqs } from "@/data/faqs";
import { faqJsonLd } from "@/lib/seo";

export default function Contact() {
    const { t } = useLang();
    return (
        <div data-testid="contact-page" className="relative">
            <Seo
                title="Contact Abhijit JK — Business Growth Consultant, Bengaluru"
                description="Get in touch with Abhijit JK, Founder of Ragi Media. Email info@abhijit.pro, call or WhatsApp +91 99866 16397 for brand and business growth consulting across India."
                keywords="contact Abhijit JK, business consultant contact, Ragi Media contact, business growth consultant Bengaluru"
                path="/contact"
                jsonLd={faqJsonLd(contactFaqs)}
            />
            <section className="mx-auto max-w-7xl px-6 pt-20 pb-10 lg:px-10">
                <Reveal>
                    <SectionEyebrow>{t("contact_eyebrow")}</SectionEyebrow>
                </Reveal>
                <Reveal delay={0.1}>
                    <h1 className="mt-6 max-w-3xl font-display text-4xl font-semibold leading-[1.05] tracking-tighter sm:text-5xl lg:text-6xl">
                        {t("contact_pre")}{" "}
                        <span className="gold-text">{t("contact_gold")}</span>
                    </h1>
                </Reveal>
                <Reveal delay={0.15}>
                    <p className="mt-6 max-w-2xl text-base text-white/65 md:text-lg">
                        {t("contact_sub")}
                    </p>
                </Reveal>
            </section>

            <section className="mx-auto grid max-w-7xl gap-10 px-6 pb-24 lg:grid-cols-12 lg:px-10">
                <Reveal className="lg:col-span-5">
                    <div className="glass rounded-lg p-8 md:p-10">
                        <p className="label-eyebrow">Reach me directly</p>
                        <ul className="mt-6 space-y-5 text-sm text-white/75">
                            <li className="flex items-center gap-4">
                                <span className="flex h-10 w-10 items-center justify-center rounded-sm bg-gold-300/10 text-gold-300">
                                    <Mail size={16} />
                                </span>
                                {CONTACT_EMAIL}
                            </li>
                            <li className="flex items-center gap-4">
                                <span className="flex h-10 w-10 items-center justify-center rounded-sm bg-gold-300/10 text-gold-300">
                                    <Phone size={16} />
                                </span>
                                +91 99866 16397
                            </li>
                            <li className="flex items-center gap-4">
                                <span className="flex h-10 w-10 items-center justify-center rounded-sm bg-gold-300/10 text-gold-300">
                                    <MapPin size={16} />
                                </span>
                                Bengaluru, India
                            </li>
                        </ul>
                        <a
                            href={WHATSAPP_LINK}
                            target="_blank"
                            rel="noreferrer"
                            data-testid="contact-whatsapp"
                            className="ghost-button mt-8 inline-flex items-center gap-2"
                        >
                            <MessageCircle size={14} /> Chat on WhatsApp
                        </a>
                    </div>
                </Reveal>

                <Reveal delay={0.1} className="lg:col-span-7">
                    <div className="glass glow-border rounded-lg p-8 md:p-10">
                        <ContactForm />
                    </div>
                </Reveal>
            </section>

            <FAQ items={contactFaqs} eyebrow="FAQ" title="Before you reach out —" gold="quick answers." />
        </div>
    );
}
